import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const HEIGHT = 44;
const PADDING = 8;

const mintChoiceSwitchStyles = {
  primary: (
    theme: Theme,
    {
      disabledLabel,
      enabledLabel,
      buttonTextColorHex,
    }: {
      disabledLabel: string;
      enabledLabel: string;
      buttonTextColorHex: string;
    },
  ): SystemStyleObject<Theme> => ({
    "&.MuiSwitch-root": {
      width: "100%", // Full width
      height: HEIGHT + 2 * PADDING,
      border: `1px solid ${theme.palette.text.primary}`,
      ...theme.typography.h5,
    },
    "& .MuiSwitch-switchBase": {
      width: "50%", // Half of the root width
      padding: `${PADDING}px`,
      height: "100%",
      color: `${theme.palette.secondary.main} !important`,
      borderRadius: 0,
      "&.Mui-checked": {
        transform: `translateX(100%)`, // Move the thumb to the end of the switch when checked
      },
      "& .MuiSwitch-thumb": {
        width: `calc(100%)`, // Adjusted width to fit within the base
        height: HEIGHT,
        borderRadius: 0,
        backgroundImage: `linear-gradient(0deg, ${theme.palette.secondary.dark}, ${theme.palette.secondary.main})`,
      },
    },

    "& .MuiSwitch-track": {
      borderRadius: 0,
      position: "relative",
      opacity: "1 !important",
      color: buttonTextColorHex,
      background: "transparent !important",
      zIndex: 1,
      pointerEvents: "none",
      "&:before, &:after": {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: "50%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
      },
      "&:before": {
        content: `"${disabledLabel}"`,
        left: 0,
        paddingRight: `${PADDING}px`,
      },
      "&:after": {
        content: `"${enabledLabel}"`,
        right: 0,
        paddingLeft: `${PADDING}px`,
      },
    },
  }),
};

export default mintChoiceSwitchStyles;
